const defaultOptions = {
  key: 'collection',
  constructor: data => data,
  defaultValue: null
}

export const collectionGetters = (adapter, options = {}) => {
  const { key, constructor, defaultValue } = {
    ...defaultOptions,
    ...options
  }

  return {
    getAll: (state, getters) => adapter.getAll(getters.getCollection).map(constructor),
    getCollection: (state) => state[key],
    itemGetter: (state, getters) => id => {
      const data = adapter.getOne(id, getters.getCollection)

      if (!data) {
        return defaultValue
      }

      return constructor(data)
    },
    filteredGetter: (state, getters) => filter => adapter.getAll(getters.getCollection).filter(filter).map(constructor),
    findGetter: (state, getters) => filter => {
      const data = adapter.getAll(getters.getCollection).find(filter)

      if (!data) {
        return defaultValue
      }

      return constructor(data)
    }
  }
}
